/**
 * 画像検索用VOクラス
 *
 * @export KYMW0B00OutputModel
 * @class KYMW0B00OutputModel
 */
export class KYMW0B00OutputModel {
  // Pコード
  public pcodeList = String('');
  // 商品案内用商品名
  public guideGoodsName = String('');
  // 商品案内用規格名
  public guideStandardName = String('');
  // 部門コード
  public classCode = String('');
  // 画像名
  public imageName = String('');
  // 画像ファイル名
  public imageFileName = String('');
  // 画像所属
  public imageBelongID = String('');
  // 画像種類
  public imageKind = String('');
  // 画像種別
  public imageType = String('');
  // 調理指示
  public processInstruct = String('');
  // 調理例掲載区分
  public cookingExPublish = String('');
  // 備考
  public remarks = String('');
  // 料理分類
  public cookingDiv = String('');
  // 料理名
  public cookingName = String('');
  // 材料名
  public materialName = String('');
  // キーワード
  public keyWord = String('');
  // 季節・催事
  public eventID = String('');
  // 撮影場所区分
  public photoContentsDiv = String('');
  // 撮影場所ID
  public photoStudioID = String('');
  // 作成指示者
  public imageInstructUser = String('');
  // 繰越
  public carriedForward = Boolean('');
  // 変更前撮影予定日
  public photographingChangeSchedule = Boolean('');
  // 複数コード登録
  public multipleCode = Boolean('');
  // スタジオ
  public studio = String('');
  // 使用開始受注コード
  public startOrderCode = String('');
  // 使用開始配達企画回(翌週)
  public startDelivCatalogId = String('');
  // 請求先名
  public billingName = String('');
  // バイヤーコード
  public buyerCode = String('');
  // C2PFステータス
  public c2pfStatus = String('');
  // 画像使用方法
  public imageUse = String('');
  // C2PF対象
  public c2pfTarget = Boolean('');
  // 取引先コメント
  public supplierComment = Boolean('');
  // 作成指示日(開始)
  public imageInstructDateStart = String('');
  // 作成指示日(終了)
  public imageInstructDateEnd = String('');
  // ファイル登録日(開始)
  public fileRegistDateStart = String('');
  // ファイル登録日(終了)
  public fileRegistDateEnd = String('');
  // 画像ステータス
  public status = String('');
  // 画像作成指示
  public imageInstrucrDiv = String('');
  // 画像使用不可
  public imageEnableDiv = String('');
  // 出力/未出力選択
  public outputFlg = String('');
  // 撮影予定日(開始)
  public photoScheduleStart = String('');
  // 撮影予定日(終了)
  public photoScheduleEnd = String('');
}
